'use client';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

import { DEFAULT_DAY, DEFAULT_FORMAT } from '@/lib/common/name-space';
import { useEffect, useState } from 'react';

type DatePickersProps = {
  label: string;
  helperText?: string;
  setValue?: (value: any) => void;
  poolName?: string;
  defaultValue?: string;
};
export default function DatePickers(aPayload: DatePickersProps): JSX.Element {
  const { label, helperText, setValue, poolName, defaultValue } = aPayload;
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);
  // const [cleared, setCleared] = useState<boolean>(false);
  // React.useEffect(() => {
  //   if (cleared) {
  //     const timeout = setTimeout(() => {
  //       setCleared(false);
  //     }, 1500);

  //     return () => {
  //       clearTimeout(timeout);
  //     };
  //   }
  // }, [cleared]);
  useEffect(() => {
    if (defaultValue) {
      setSelectedDate(dayjs(defaultValue));
    } else {
      setSelectedDate(null);
    }
  }, [defaultValue]);

  const handleDate = (aDate: dayjs.Dayjs | null) => {
    const formattedDate = aDate ? aDate.format('YYYY-MM-DD') : '';
    if (setValue && poolName) {
      setValue((prevValue: any) => ({
        ...prevValue,
        [poolName]: formattedDate,
      }));
    }
    setSelectedDate(aDate); // 상태 업데이트
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={selectedDate}
        formatDensity={undefined}
        enableAccessibleFieldDOMStructure={undefined}
        selectedSections={undefined}
        onSelectedSectionsChange={undefined}
        format="YYYY-MM-DD"
        onChange={handleDate}
        slotProps={
          {
            // textField: {
            //   helperText: { helperText },
            // },
            // field: { clearable: true, onClear: () => setCleared(true) },
          }
        }
      />
    </LocalizationProvider>
  );
}

// function IsDefaultValue({ item }: { item: DatePickersProps }) {
//   const { label, helperText, setValue, poolName, defaultValue } = item;
//   return (
//     <DatePicker
//       defaultValue={dayjs(defaultValue).format(DEFAULT_DAY)}
//       label={label}
//       formatDensity={undefined}
//       enableAccessibleFieldDOMStructure={undefined}
//       selectedSections={undefined}
//       onSelectedSectionsChange={undefined}
//       format='YYYY-MM-DD'
//       onChange={handleDate}
//       slotProps={
//         {
//           // textField: {
//           //   helperText: { helperText },
//           // },
//           // field: { clearable: true, onClear: () => setCleared(true) },
//         }
//       }
//     />
//   );
// }
// function IsNotDefaultValue() {
//   return (
//     <DatePicker
//       label={label}
//       formatDensity={undefined}
//       enableAccessibleFieldDOMStructure={undefined}
//       selectedSections={undefined}
//       onSelectedSectionsChange={undefined}
//       format='YYYY-MM-DD'
//       onChange={handleDate}
//       slotProps={
//         {
//           // textField: {
//           //   helperText: { helperText },
//           // },
//           // field: { clearable: true, onClear: () => setCleared(true) },
//         }
//       }
//     />
//   );
// }
